import { Button, Flex, Modal, Table } from "@mantine/core";
import { useEffect, useState } from "react";
import styled from "styled-components";
import { deleteApplicant, getApplicantList } from "../../api/applicantApi";
import { deleteNotification } from "../../utils/useNotification";
import CustomSearchInput from "../common/Inputs/CustomSearchInput";
import TableDeleteButton from "../common/Buttons/TableDeleteButton";
import CustomPagination from "../common/CustomPagination";
import AreYouSureModal from "../common/Modals/AreYouSureModal";
import { useLocation, useNavigate } from "react-router";
import { theme } from "../../theme";
import CustomSelect from "../common/Inputs/CustomSelect";
import { useAuth } from "../../context/AuthContext";

const ApplicantTable = () => {
  const { roleSelectData, departmentSelectData } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const [page, setPage] = useState(1);
  const [limit, setLimit] = useState(5);
  const [totalPages, setTotalPages] = useState(1);
  const [totalItems, setTotalItems] = useState(0);
  const [tableData, setTableData] = useState<any[]>([]);
  const [openDeleteModal, setOpenDeleteModal] = useState(false);
  const [itemToDeleted, setItemToDeleted] = useState<any>(null);

  // for filters
  const [searchedName, setSearchedName] = useState<string>("");
  //for department select
  const [selectedDepartment, setSelectedDepartment] = useState<any>();
  //for sort
  const [sort, setSort] = useState<any>("");
  //for position select
  const [selectedPosition, setSelectedPosition] = useState<any>();

  const getTableData = async () => {
    try {
      const { data }: any = await getApplicantList({
        pageNumber: page,
        limit: limit,
        name: searchedName,
        department: selectedDepartment,
        role: selectedPosition,
      });
      setTableData(data?.data || []);
      setPage(data?.meta?.page || 1);
      setLimit(data?.meta?.limit || 5);
      setTotalPages(data?.meta?.totalPages || 1);
      setTotalItems(data?.meta?.total || 0);
    } catch (error) {
      console.error("Error fetching applicants:", error);
    }
  };

  const handleDeleteClick = async (id: string) => {
    try {
      const { data }: any = await deleteApplicant({ id });
      deleteNotification(data?.success);
      getTableData();
    } catch (error) {
      console.error("Error deleting applicant:", error);
    }
  };

  useEffect(() => {
    getTableData();
  }, [page, searchedName, selectedDepartment, searchedName, selectedPosition]);

  return (
    <>
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
        }}
      >
        <div
          style={{
            overflowY: "auto",
            minHeight: "422px",
            width: "100%",
            border: "1px solid #D1D5DB",
            borderRadius: "6px",
          }}
        >
          <Flex p={"12px 16px"} justify={"space-between"}>
            <CustomSearchInput
              value={searchedName}
              w={220}
              placeholder="Ad Soyad"
              onChange={(event: any) => {
                setPage(1);
                setSearchedName(event.currentTarget.value);
              }}
            />
            <Flex gap={8}>
              <CustomSelect
                placeholder="Departman"
                data={departmentSelectData}
                onChange={(e: any) => {
                  setSelectedDepartment(e);
                  setPage(1);
                }}
              />
              <CustomSelect
                placeholder="Rol"
                data={roleSelectData}
                onChange={(e: any) => {
                  setSelectedPosition(e);
                  setPage(1);
                }}
              />
            </Flex>
          </Flex>
          <Table style={{ borderCollapse: "separate" }} verticalSpacing="sm">
            <Table.Thead style={{ background: "#EEF2FF" }}>
              <Table.Tr>
                <StyledTableTh>Ad Soyad</StyledTableTh>
                <StyledTableTh>Telefon</StyledTableTh>
                <StyledTableTh>Departman</StyledTableTh>
                <StyledTableTh>Rol</StyledTableTh>
                <StyledTableTh></StyledTableTh>
              </Table.Tr>
            </Table.Thead>
            <Table.Tbody>
              {tableData?.map((applicant: any) => (
                <StyledTableTr
                  style={{
                    color: "#111827",
                    fontSize: "16px",
                    fontWeight: "400",
                  }}
                  key={applicant?._id}
                >
                  <Table.Td style={{ width: "20%" }}>
                    {applicant?.name}
                  </Table.Td>

                  <Table.Td style={{ width: "20%" }}>
                    {applicant?.phone || "-"}
                  </Table.Td>
                  <Table.Td>
                    {applicant?.departments && applicant.departments.length > 1
                      ? "Birden fazla"
                      : applicant?.departments?.[0]?.label ||
                        "Departman bilgisi yok"}
                  </Table.Td>
                  <Table.Td>
                    {applicant?.roles && applicant.roles.length > 1
                      ? "Birden fazla"
                      : applicant?.roles?.[0]?.label || "Rol bilgisi yok"}
                  </Table.Td>
                  <Table.Td style={{ width: "0%" }}>
                    <Flex align={"center"} gap={15}>
                      <Button
                        color={theme.colors.brand.normal}
                        onClick={(e) => {
                          e.stopPropagation();
                          navigate(`/employees/new`, {
                            state: {
                              applicant: applicant,
                            },
                          });
                        }}
                      >
                        İşe Al
                      </Button>
                      <TableDeleteButton
                        onClick={(e: any) => {
                          e.stopPropagation();
                          setItemToDeleted(applicant);
                          setOpenDeleteModal(true);
                        }}
                      />
                    </Flex>
                  </Table.Td>
                </StyledTableTr>
              ))}
            </Table.Tbody>
          </Table>
        </div>
        <div style={{ position: "absolute", bottom: "-20px" }}>
          <CustomPagination
            total={totalPages}
            value={page}
            onChange={setPage}
          />
        </div>
      </div>

      <AreYouSureModal
        opened={openDeleteModal}
        setOpened={setOpenDeleteModal}
        proccessFunc={() => handleDeleteClick(itemToDeleted._id)}
        title="Aday Sil"
        text="Bu adayı silmek istediğinizden emin misiniz?"
        confirmButtonText="Sil"
        cancelButtonText="Vazgeç"
      />
    </>
  );
};

export default ApplicantTable;

const StyledTableTh = styled(Table.Td)`
  color: #4c4c4c;
  font-size: 14px;
  font-weight: 600;
  line-height: 16px;
`;

const StyledTableTr = styled(Table.Tr)``;
